import { API, PageModel, Project, ProjectAPI } from "@brg/api";
import {LayoutConst, useModal} from "core";
import { FC, useCallback, useEffect, useMemo, useState } from "react";
import SortableList, {SortableItem, SortableKnob} from "react-easy-sort";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { CreateLinkTo } from "shared/constants/linkTo";
import styled, {createGlobalStyle, useTheme} from 'styled-components';
import {Colors, FlexBox, useBreakpoint, useIsMobile} from "@brg/ui";
import { DefaultButton } from "shared/pages/teams/styles";
import { ProjectEditPageGridInput } from "_deziiign/books/pages/BookEdit/styles";
import {Input} from "@brg/input";
import DeleteIcon from "../../../../../shared/icons/DeleteIcon";
import {ReactComponent as PlusSvg } from "../../../../../shared/pages/projectEdit/close.svg";
import { arrayMoveImmutable } from 'shared/utils/arrayMove';
import DragIcon from "../../../../../shared/icons/DragIcon";
import { MODAL_TYPE } from "shared/modals/selectShortList/SelectShortList";
import { CompetitionModalTabs } from "./components/CompetitionModalTabs";

export const TableWrapper = styled.table`

    th {
        color: ${({ theme }) => theme.competition.label.color};
        padding-bottom: 8px;
        font-weight: 400;
    }

    td {
        
        // padding: 10px 16px;
        padding: 0;
        min-height: 42px;
        max-height: 42px;
        border-bottom: 12px solid ${({ theme }) => theme.competition.table.input.border} !important;
        border-right: 8px solid ${({ theme }) => theme.competition.table.input.border}  !important; 
        border-bottom: 0px solid ${({ theme }) => theme.competition.table.input.border};
        border-right: 0px solid ${({ theme }) => theme.competition.table.input.border}; 
        border-color: transparent !important;
        border-radius: 3px;
        border-spacing: 0px;
    }

    .td-content {
      display: flex;
      justify-conten: flex-start;
      place-items: center;

      &:not(.td-delete) {
        padding: 10px 16px;
        height: auto;
        min-height: 42px;
        background-color: ${({ theme }) => theme.competition.table.input.bg} !important;
      }

      @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        height: 36px;
      }
    }

    .td-dropdown {
      flex-flow: row;
      padding: 0 !important;
      height: 42px !important;
      width: 45px;

      @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        height: 36px;
      }
    }

    .delete-block {
        padding-left: 0 !important;
        padding-right: 0 !important;
    }


    *:not(th) {
        font-size: 17px;
        line-height: 22px;
        font-weight: 400;
        letter-spacing: -0.02em;

        @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
            font-size: 13px;
            line-height: 16px;
        }
    }

  .width-place {
    width: 49px;
  }
  .width-name, .width-author {
    width: 213px;
  }
  .width-points {
    width: 57px;
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    .width-place {
      width: 49px;
    }
    .width-name, .width-author {
      width: 243px;
    }
    .width-points {
      width: 57px;
    }
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    .width-name, .width-author {
      width: 50%;
    }

    tr {
      height: auto !important;
      min-height: 42px;
    }

    td {
      max-height: none;
      min-height: 42px;
      height: auto;
    }

    .td-content {
      height: 100%;
      
      &:not(.td-delete) {
        padding: 10px 16px;
        height: 100%;
        min-height: 42px;
      }
    }

  }
  
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    th {
      font-size: 10px;
      line-height: 13px;
    }

    td {
      position: relative;
    }

    .td-content {
      height: 100%;
      min-height: 48px;
      max-height: none;
      
      &:not(.td-delete) {
        padding: 8px 12px;
        // height: auto;
        min-height: 48px;
      }
    }
  }

`;


export const TdTitle = styled.td`
  // background-color: ${({ theme }) => theme.competition.table.input.bg} !important;
  background-color: transparent;
  color: ${({ theme }) => theme.competition.table.input.color} !important;
  font-size: 17px;
  line-height: 22px;
  font-weight: 400;
  height: 42px;
  width: 50%;
`

export const TdAuthor = styled.td`
  // background-color: ${({ theme }) => theme.competition.table.input.bg};
  background-color: transparent;
  color: ${({ theme }) => theme.competition.table.input.color};
  font-size: 17px;
  line-height: 22px;
  font-weight: 400;
  width: 50%;
`

export const TdSum = styled.td`
  // background-color: ${({ theme }) => theme.competition.table.input.bg};
  background-color: transparent;
  color: ${({ theme }) => theme.competition.table.input.color};
  text-align: center;
  font-size: 17px;
  line-height: 22px;
  font-weight: 400;
  width: 65px !important;
  min-width: 65px;
`;

export const TdDel = styled.td`
  padding: 0 !important;
  width: 24px !important;
  max-width: 24px !important;
  min-width: 24px !important;
`;

export const TdPlace = styled.td`
  // background-color: ${({ theme }) => theme.competition.table.input.bg};
  background-color: transparent;
  text-align: center;
  padding: 0 0 0 8px;
  color: ${({ theme }) => theme.competition.table.input.color}; rgba(144, 144, 144, 1);

  .brg-input__control {
    height: auto!important;
    min-height: unset;
  }
  .brg-input__value-container {
    height: 24px!important;
  }
  .brg-input__indicator {
    padding: 0!important;
    height: auto!important;
  }
  .brg-input__indicators {
    align-items: center;
  }

  input:focus {
    outline: none;
  }
`

export const TdButton = styled.td`
  text-align: center;
  padding: 0!important;
`

export const TdDrag = styled.td`
  cursor: grab;
  padding-left: 0 !important;
  padding-right: 0 !important;
  svg {
    path {
      fill: ${Colors.galBlack47}
    }
  }
`

const GlobalDragStyle = createGlobalStyle`

.sortable-short-list-item {
    // background: ${({ theme }) => theme.competition.table.item.bg}; !important;
    background: transparent !important;
    height: 42px;
    border-bottom: 12px;
}

    .sortable-short-list-item-draggable {
      // width: 500px;
      display: flex;
      align-items: center;
      justify-content: start;
      padding: 0 12px;
      gap: 8px;
      padding: 0;
      border: 0;
      background: #343434 !important;

      td {
        height: 100%;
        display: flex;
        align-items: center;
        padding: 0 12px;

        // a, .brg-input__single-value {
        //   color: rgba(144, 144, 144, 1);
        // }

        
        padding: 0;
        min-height: 42px;
        max-height: 42px;
        border: 0!important;
        // border-bottom: 12px solid ${({ theme }) => theme.competition.table.input.border} !important;
        // border-right: 8px solid ${({ theme }) => theme.competition.table.input.border}  !important; 
        // border-bottom: 0px solid ${({ theme }) => theme.competition.table.input.border};
        // border-right: 0px solid ${({ theme }) => theme.competition.table.input.border}; 
        border-color: transparent !important;
        border-radius: 3px;
        border-spacing: 0px;

        .td-content {
          display: flex;
          justify-content: flex-start;
          place-items: center;
          width: 100%;
          border: 0!important;

          &, & div, & a {
            color: inherit !important;
          }

          &.td-sum {
            max-width: 58px;
            width: 58px;
            border: 0!important;
            margin-left: -1px;
          }
          &.td-title {
            width: 385px;
            border: 0!important;
            @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
              width: 285px;
            }
          }

          &.td-author{
            width: 386px;
            border: 0!important;
            @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
              width: 285px;
            }
          }
          &:not(.td-delete) {
            padding: 10px 16px;
            height: auto;
            min-height: 42px;
            background-color: ${({ theme }) => theme.competition.table.input.bg} !important;
          }
          &.td-delete {
            max-width: 19px;
            border: 0!important;
            padding: 0 !important;
            margin-left: -9px;
            svg {
              max-width: 17px;
            }
          }

          @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
            height: 36px;
          }
        }

        .td-dropdown {
          flex-flow: row;
          padding: 0 !important;
          height: 42px !important;
          width: 45px;
          
          .brg-input__control {
            background: inherit;
          }

          @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
            height: 36px;
          }
        }

        *:not(th) {
            font-size: 17px;
            line-height: 22px;
            font-weight: 400;
            letter-spacing: -0.02em;

            @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
                font-size: 13px;
                line-height: 16px;
            }
        }
      }
      ${TdTitle}, ${TdAuthor} {
        width: 100%;
      }

      @media (max-width: ${LayoutConst.screen.s}px) {
        width: calc(100vw - 20px);
      }
    }
`;


const AddWinnerbutton = styled(DefaultButton)`
  height: 100%;
  width: 100%;
  border-color: ${Colors.galBlack31};
  font-size: 15px!important;
  padding: 8px 16px!important;
  line-height: 20px!important;
`

const WinnerInputWrapper = styled(ProjectEditPageGridInput)`

background-color: #464645 !important;
  width: 52px !important;
  .brg-input__value-container {
    padding: 0!important;
  }
  .brg-input__single-value {
    width: 22px!important;
  }
  .brg-input__indicators {
    width: 13px!important;
    margin-right: 8px;
  }
  .brg-input__indicator {
    padding-left: 0;
    padding-right: 0;
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    width: 33px !important;
  }

`;

interface ShortListProjectsEditProps {
    competitionId: string;
    projects: { winnerId: string, position: number }[];
    onSetProjects: (projectIds:string[], position?: number) => void;
    onRebuildProjects: (items: {project?: Project, position?: number, isEmpty?: boolean, projectId?: string}[], isDelete?: boolean) => void;
    onSetPosition: (index: number, position: number) => void;
    onSort: (oldIndex: number, newIndex: number) => void;
    draggable?: boolean;
};

export const ShortListWinnerProjectsEdit: FC<ShortListProjectsEditProps> = ({
    competitionId,
    projects,
    onSetProjects,
    onRebuildProjects,
    onSetPosition,
    onSort,
    draggable = false
}) => {
    const { t, i18n } = useTranslation();
    const modal = useModal();
    const isMobile = useBreakpoint(LayoutConst.screen.s - 1);
 
    const [editedItems, setEditedItems] = useState<({ project?: Project, position?: number, isEmpty?: boolean, projectId?: string })[]>([]);

    useEffect(() => {

        if (projects.length) {
            ProjectAPI.GetList({
                    projectIds: projects.map(x => x.winnerId),
                    projectFilter: 1,
                    isLite: true,
                    isContextIgnored: true,
                    onlyBooks: ''
                })
                .then(v => v.json())
                .then((v) => API.toLang<PageModel<Project>>(v, i18n.language))
                .then((v) => {
                    if (v?.data?.length) {
                        const prjs = [...v.data];
                        prjs.sort((a: Project, b: Project): number => {
                            const index_a = projects.map(x => x.winnerId).indexOf(a.projectId);
                            const index_b = projects.map(x => x.winnerId).indexOf(b.projectId);

                            if (index_a < index_b) {
                              return -1;
                            }
                            if (index_a > index_b) {
                              return 1;
                            }
                            // a must be equal to b
                            return 0;
                        });

                        const prjItems = prjs.map(x => {
                            const winner = projects.find(f => f.winnerId === x.projectId);

                            return { project: x, position: winner?.position ?? 1 }
                        });

                        setEditedItems([...prjItems])
                    } 
                });
        }
    }, [projects, i18n]);

    const tabsComponent = useMemo(() => (<CompetitionModalTabs />), [])

    const onAddProject = useCallback((index: number, projectId: string) => {
        const temp = [...editedItems];
        temp[index] = {...temp[index], projectId: projectId }
        setEditedItems(temp);
    }, [editedItems])

    const onSelectClick = useCallback((index: number, position?: number) => {
        modal.show('select-short-list', {
            competitionId: competitionId,
            projectIds: projects.filter(x => x.winnerId !== '')?.map((i) => i?.winnerId),
            onSetProjects: onSetProjects,
            onAddProject: onAddProject,
            sortingMethods: [1,2,13],
            searchData: { id: competitionId },
            sendText: t('competitions_edit.btns.save'),
            modalType: MODAL_TYPE.short_list,
            position: position,
            index: index,
            tabs: tabsComponent,
        });
    }, [modal, tabsComponent, competitionId, projects, onSetProjects, onAddProject, t]);

    const onSortEnd = useCallback((oldIndex: number, newIndex: number) => {
        const arr = arrayMoveImmutable(editedItems, oldIndex, newIndex)
        setEditedItems(arr)
        onRebuildProjects(arr)
    }, [onSort, editedItems])

    const onSetLocalPosition = useCallback((index: number, position: number, isEmpty?: boolean) => {
        const temp = [...editedItems];
        temp[index].position = position;
        setEditedItems(temp);
        if (!isEmpty) onSetPosition(index, position)
    }, [onSetPosition, editedItems])

    const onDelete = useCallback((index: number, position?: number) => {
        const temp = [...editedItems];
        temp.splice(index, 1);
        onRebuildProjects(temp.map(x => ({projectId: x?.project?.projectId || "", position: x?.position, isEmpty: false})), true)
        setEditedItems(temp.map(x => ({projectId: x?.project?.projectId || "", position: x?.position, isEmpty: false})));
    }, [editedItems, onRebuildProjects])

    if (!editedItems?.length) {
        return (
            <DefaultButton isCompetitionEdit onClick={() => onSelectClick(0)} hollow>{t('competition_edit.choose_winner_new')}</DefaultButton>
        )
    }

    return (
        <FlexBox direction="column" directionMobile="column" gy={12} gyMobile={12}>
        <GlobalDragStyle/>
        <TableWrapper width={'100%'} >
          <thead>
            <tr>
              <th className=''>{isMobile ? 'Место' : ''}</th>
              <th className='width-place vertical-th jury-sum'>
                  {!isMobile ? 'Место' : 'Проект'}
              </th>
              <th className='width-name project-name'>
                  {isMobile ? 'Автор' : 'Проект'}
              </th>
              <th className='width-author author-name'>{isMobile ? 'Балл' : 'Автор'}</th>
              <th className='width-points vertical-th jury-sum'>{isMobile ? '': 'Балл'}</th>
              <th className=''></th>
            </tr>
          </thead>
                        {draggable
                            ? <SortableList as={'tbody'}  onSortEnd={onSortEnd} className="sortable-short-list" lockAxis="y" draggedItemClassName="sortable-short-list-item-draggable">
                                    {editedItems?.map((value, index) => {
                                        const projectTitle: any = !!value?.project?.title ? value.project.title : value.project?.additionalContent?.title?.text;
                                        if (value?.isEmpty !== undefined) return <SortableItem key={index + "sortable-empty"}>
                                            <tr className="sortable-short-list-item" style={{height: 42}}>
                                                <td className={''}></td>
                                                <TdPlace>
                                                    <WinnerInputWrapper 
                                                        className={'td-content'}
                                                        direction="column"
                                                        directionMobile="column" isTeamEdit
                                                        >
                                                        {value?.position || 1}
                                                    </WinnerInputWrapper>
                                                </TdPlace>
                                                <TdButton>
                                                    <AddWinnerbutton onClick={() => onSelectClick(index, value?.position)}>{t('competition_edit.choose_winner')}</AddWinnerbutton>
                                                </TdButton>
                                            </tr>
                                        </SortableItem>

                                        if (value?.project && value?.position !== undefined) return <SortableItem key={value.project.projectId + "sortable"}>
                                            <tr className="sortable-short-list-item" style={{height: 42 }}>
                                                <TdDrag width={24}>
                                                    <SortableKnob>
                                                        <DragIcon/>
                                                    </SortableKnob>
                                                </TdDrag>
                                                <TdPlace>
                                                    <WinnerInputWrapper 
                                                      className={'td-content td-dropdown'}
                                                      direction="column"
                                                      directionMobile="column" 
                                                      isTeamEdit
                                                      >
                                                        <Input.Text
                                                          value={value?.position}
                                                          onChange={(ev: any) => {
                                                            onSetLocalPosition(index, Number(ev.target.value))
                                                          }}
                                                        />
                                                    </WinnerInputWrapper>
                                                </TdPlace>
                                                <TdTitle>
                                                    <div className={'td-content td-title'}>
                                                        <Link to={CreateLinkTo.projectNew(value.project)}
                                                              target={"_blank"}>{projectTitle}</Link>&nbsp;&nbsp;
                                                    </div>
                                                </TdTitle>
                                                <TdAuthor>
                                                  <div className={'td-content td-author'}>
                                                    <Link to={CreateLinkTo.designerNew(value.project.author)}
                                                          target={"_blank"}>{value.project.author.name + ' ' + value.project.author.surName}</Link>&nbsp;&nbsp;
                                                          </div>
                                                </TdAuthor>
                                                <TdSum>
                                                    <div className={'td-content td-sum'}  style={{ justifyContent: 'center' }}>
                                                        {value.project.competitonsGPA?.find(x => x.competitionId === competitionId)?.competitionGPA ?? "0"}
                                                    </div>
                                                </TdSum>
                                                <TdDel>
                                                    <div className={'td-content td-delete'} style={{cursor: 'pointer'}} onClick={() => onDelete(index, value?.position)}>
                                                      <DeleteIcon/>
                                                    </div>
                                                </TdDel>
                                            </tr>
                                        </SortableItem>
                                    })}
                                </SortableList>
                            : <tbody className="short-list">
                                    {editedItems?.map((value, index) => {
                                        const projectTitle: any = !!value?.project?.title ? value.project.title : value.project?.additionalContent?.title?.text;
                                        if (value?.isEmpty !== undefined) return <tr className="sortable-short-list-item" style={{height: 42}}>
                                                <TdPlace>
                                                    <WinnerInputWrapper 
                                                      className={'td-content'} 
                                                      direction="column"
                                                      directionMobile="column" 
                                                      isTeamEdit
                                                    >
                                                        <Input.Dropdown
                                                            value={{
                                                                label: value?.position || 1,
                                                                value: value?.position || 1
                                                            }}
                                                            onChange={(ev: any) => onSetLocalPosition(index, Number(ev.value), true)}
                                                            options={[{label: 1, value: 1}, {label: 2, value: 2}, {label: 3, value: 3}, {label: 4, value: 4}, {
                                                                label: 5,
                                                                value: 5
                                                            }]
                                                          }
                                                        />
                                                    </WinnerInputWrapper>
                                                </TdPlace>
                                                <TdButton>
                                                    <AddWinnerbutton onClick={() => onSelectClick(index, value?.position)}>{t('competition_edit.choose_winner')}</AddWinnerbutton>
                                                </TdButton>
                                            </tr>

                                        if (value?.project && value?.position !== undefined) return <tr className="sortable-short-list-item" style={{height: 42}}>
                                                <TdPlace>
                                                    <WinnerInputWrapper 
                                                      className={'td-content'} 
                                                      direction="column"
                                                      directionMobile="column" 
                                                      isTeamEdit
                                                    >
                                                        
                                                        {!isMobile ? (
                                                          <Input.Dropdown
                                                            value={{
                                                                label: value?.position || 1,
                                                                value: value?.position || 1
                                                            }}
                                                            onChange={(ev: any) => onSetPosition(index, Number(ev.value))}
                                                            options={
                                                              [{label: 1, value: 1}, {label: 2, value: 2}, {label: 3, value: 3}, {label: 4, value: 4}, {
                                                                label: 5,
                                                                value: 5
                                                            }]
                                                          }
                                                          />
                                                        ) : (
                                                          <span>{index + 1}</span>
                                                        )}
                                                       
                                                    </WinnerInputWrapper>
                                                </TdPlace>
                                                <TdTitle width={'100% !important'}>
                                                    <div className={'td-content'} style={{ width: '100%' }}>
                                                        <Link to={CreateLinkTo.projectNew(value.project)}
                                                              target={"_blank"}>{projectTitle}</Link>&nbsp;&nbsp;
                                                    </div>
                                                </TdTitle>
                                                <TdAuthor>
                                                    <Link className={'td-content'} style={{ height: '100%'}} to={CreateLinkTo.designerNew(value.project.author)}
                                                          target={"_blank"}>{value.project.author.name + ' ' + value.project.author.surName}</Link>&nbsp;&nbsp;
                                                </TdAuthor>
                                                <TdSum style={{ width: '65px !important'}}>
                                                    <div className={'td-content'} style={{ placeItems: 'center' }}>
                                                        {value.project.competitonsGPA?.find(x => x.competitionId === competitionId)?.competitionGPA ?? "Нет оценок"}
                                                    </div>
                                                </TdSum>
                                                {!isMobile && (
                                                  <TdDel style={{ width: '24px !important' }}>
                                                    <div className={'td-content td-delete'} style={{cursor: 'pointer'}} onClick={() => onDelete(index, value?.position)}>
                                                        <DeleteIcon/>
                                                    </div>
                                                  </TdDel>
                                                )}
                                            </tr>
                                    })}
                                </tbody>
                        }
        </TableWrapper>
            {editedItems?.some((i: any) => !i?.isEmpty) && <div>
                <DefaultButton isCompetitionEdit hollow onClick={() => onSelectClick(projects?.length, projects?.length + 1)}><PlusSvg />{t('competition_edit.add_win_place')}</DefaultButton>
            </div>}
        </FlexBox>
    );
};import { API, PageModel, Project, ProjectAPI } from "@brg/api";
import {LayoutConst, useModal} from "core";
import { FC, useCallback, useEffect, useMemo, useState } from "react";
import SortableList, {SortableItem, SortableKnob} from "react-easy-sort";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { CreateLinkTo } from "shared/constants/linkTo";
import styled, {createGlobalStyle, useTheme} from 'styled-components';
import {Colors, FlexBox, useBreakpoint, useIsMobile} from "@brg/ui";
import { DefaultButton } from "shared/pages/teams/styles";
import { ProjectEditPageGridInput } from "_deziiign/books/pages/BookEdit/styles";
import {Input} from "@brg/input";
import DeleteIcon from "../../../../../shared/icons/DeleteIcon";
import {ReactComponent as PlusSvg } from "../../../../../shared/pages/projectEdit/close.svg";
import { arrayMoveImmutable } from 'shared/utils/arrayMove';
import DragIcon from "../../../../../shared/icons/DragIcon";
import { MODAL_TYPE } from "shared/modals/selectShortList/SelectShortList";
import { CompetitionModalTabs } from "./components/CompetitionModalTabs";

export const TableWrapper = styled.table`

    th {
        color: ${({ theme }) => theme.competition.label.color};
        padding-bottom: 8px;
        font-weight: 400;
    }

    td {
        
        // padding: 10px 16px;
        padding: 0;
        min-height: 42px;
        max-height: 42px;
        border-bottom: 12px solid ${({ theme }) => theme.competition.table.input.border} !important;
        border-right: 8px solid ${({ theme }) => theme.competition.table.input.border}  !important; 
        border-bottom: 0px solid ${({ theme }) => theme.competition.table.input.border};
        border-right: 0px solid ${({ theme }) => theme.competition.table.input.border}; 
        border-color: transparent !important;
        border-radius: 3px;
        border-spacing: 0px;
    }

    .td-content {
      display: flex;
      justify-conten: flex-start;
      place-items: center;

      &:not(.td-delete) {
        padding: 10px 16px;
        height: auto;
        min-height: 42px;
        background-color: ${({ theme }) => theme.competition.table.input.bg} !important;
      }

      @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        height: 36px;
      }
    }

    .td-dropdown {
      flex-flow: row;
      padding: 0 !important;
      height: 42px !important;
      width: 45px;

      @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        height: 36px;
      }
    }

    .delete-block {
        padding-left: 0 !important;
        padding-right: 0 !important;
    }


    *:not(th) {
        font-size: 17px;
        line-height: 22px;
        font-weight: 400;
        letter-spacing: -0.02em;

        @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
            font-size: 13px;
            line-height: 16px;
        }
    }

  .width-place {
    width: 49px;
  }
  .width-name, .width-author {
    width: 213px;
  }
  .width-points {
    width: 57px;
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    .width-place {
      width: 49px;
    }
    .width-name, .width-author {
      width: 243px;
    }
    .width-points {
      width: 57px;
    }
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    .width-name, .width-author {
      width: 50%;
    }

    tr {
      height: auto !important;
      min-height: 42px;
    }

    td {
      max-height: none;
      min-height: 42px;
      height: auto;
    }

    .td-content {
      height: 100%;
      
      &:not(.td-delete) {
        padding: 10px 16px;
        height: 100%;
        min-height: 42px;
      }
    }

  }
  
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    th {
      font-size: 10px;
      line-height: 13px;
    }

    td {
      position: relative;
    }

    .td-content {
      height: 100%;
      min-height: 48px;
      max-height: none;
      
      &:not(.td-delete) {
        padding: 8px 12px;
        // height: auto;
        min-height: 48px;
      }
    }
  }

`;


export const TdTitle = styled.td`
  // background-color: ${({ theme }) => theme.competition.table.input.bg} !important;
  background-color: transparent;
  color: ${({ theme }) => theme.competition.table.input.color} !important;
  font-size: 17px;
  line-height: 22px;
  font-weight: 400;
  height: 42px;
  width: 50%;
`

export const TdAuthor = styled.td`
  // background-color: ${({ theme }) => theme.competition.table.input.bg};
  background-color: transparent;
  color: ${({ theme }) => theme.competition.table.input.color};
  font-size: 17px;
  line-height: 22px;
  font-weight: 400;
  width: 50%;
`

export const TdSum = styled.td`
  // background-color: ${({ theme }) => theme.competition.table.input.bg};
  background-color: transparent;
  color: ${({ theme }) => theme.competition.table.input.color};
  text-align: center;
  font-size: 17px;
  line-height: 22px;
  font-weight: 400;
  width: 65px !important;
  min-width: 65px;
`;

export const TdDel = styled.td`
  padding: 0 !important;
  width: 24px !important;
  max-width: 24px !important;
  min-width: 24px !important;
`;

export const TdPlace = styled.td`
  // background-color: ${({ theme }) => theme.competition.table.input.bg};
  background-color: transparent;
  text-align: center;
  padding: 0 0 0 8px;
  color: ${({ theme }) => theme.competition.table.input.color}; rgba(144, 144, 144, 1);

  .brg-input__control {
    height: auto!important;
    min-height: unset;
  }
  .brg-input__value-container {
    height: 24px!important;
  }
  .brg-input__indicator {
    padding: 0!important;
    height: auto!important;
  }
  .brg-input__indicators {
    align-items: center;
  }

  input:focus {
    outline: none;
  }
`

export const TdButton = styled.td`
  text-align: center;
  padding: 0!important;
`

export const TdDrag = styled.td`
  cursor: grab;
  padding-left: 0 !important;
  padding-right: 0 !important;
  svg {
    path {
      fill: ${Colors.galBlack47}
    }
  }
`

const GlobalDragStyle = createGlobalStyle`

.sortable-short-list-item {
    // background: ${({ theme }) => theme.competition.table.item.bg}; !important;
    background: transparent !important;
    height: 42px;
    border-bottom: 12px;
}

    .sortable-short-list-item-draggable {
      // width: 500px;
      display: flex;
      align-items: center;
      justify-content: start;
      padding: 0 12px;
      gap: 8px;
      padding: 0;
      border: 0;
      background: #343434 !important;

      td {
        height: 100%;
        display: flex;
        align-items: center;
        padding: 0 12px;

        // a, .brg-input__single-value {
        //   color: rgba(144, 144, 144, 1);
        // }

        
        padding: 0;
        min-height: 42px;
        max-height: 42px;
        border: 0!important;
        // border-bottom: 12px solid ${({ theme }) => theme.competition.table.input.border} !important;
        // border-right: 8px solid ${({ theme }) => theme.competition.table.input.border}  !important; 
        // border-bottom: 0px solid ${({ theme }) => theme.competition.table.input.border};
        // border-right: 0px solid ${({ theme }) => theme.competition.table.input.border}; 
        border-color: transparent !important;
        border-radius: 3px;
        border-spacing: 0px;

        .td-content {
          display: flex;
          justify-content: flex-start;
          place-items: center;
          width: 100%;
          border: 0!important;

          &, & div, & a {
            color: inherit !important;
          }

          &.td-sum {
            max-width: 58px;
            width: 58px;
            border: 0!important;
            margin-left: -1px;
          }
          &.td-title {
            width: 385px;
            border: 0!important;
            @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
              width: 285px;
            }
          }

          &.td-author{
            width: 386px;
            border: 0!important;
            @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
              width: 285px;
            }
          }
          &:not(.td-delete) {
            padding: 10px 16px;
            height: auto;
            min-height: 42px;
            background-color: ${({ theme }) => theme.competition.table.input.bg} !important;
          }
          &.td-delete {
            max-width: 19px;
            border: 0!important;
            padding: 0 !important;
            margin-left: -9px;
            svg {
              max-width: 17px;
            }
          }

          @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
            height: 36px;
          }
        }

        .td-dropdown {
          flex-flow: row;
          padding: 0 !important;
          height: 42px !important;
          width: 45px;
          
          .brg-input__control {
            background: inherit;
          }

          @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
            height: 36px;
          }
        }

        *:not(th) {
            font-size: 17px;
            line-height: 22px;
            font-weight: 400;
            letter-spacing: -0.02em;

            @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
                font-size: 13px;
                line-height: 16px;
            }
        }
      }
      ${TdTitle}, ${TdAuthor} {
        width: 100%;
      }

      @media (max-width: ${LayoutConst.screen.s}px) {
        width: calc(100vw - 20px);
      }
    }
`;


const AddWinnerbutton = styled(DefaultButton)`
  height: 100%;
  width: 100%;
  border-color: ${Colors.galBlack31};
  font-size: 15px!important;
  padding: 8px 16px!important;
  line-height: 20px!important;
`

const WinnerInputWrapper = styled(ProjectEditPageGridInput)`

background-color: #464645 !important;
  width: 52px !important;
  .brg-input__value-container {
    padding: 0!important;
  }
  .brg-input__single-value {
    width: 22px!important;
  }
  .brg-input__indicators {
    width: 13px!important;
    margin-right: 8px;
  }
  .brg-input__indicator {
    padding-left: 0;
    padding-right: 0;
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    width: 33px !important;
  }

`;

interface ShortListProjectsEditProps {
    competitionId: string;
    projects: { winnerId: string, position: number }[];
    onSetProjects: (projectIds:string[], position?: number) => void;
    onRebuildProjects: (items: {project?: Project, position?: number, isEmpty?: boolean, projectId?: string}[], isDelete?: boolean) => void;
    onSetPosition: (index: number, position: number) => void;
    onSort: (oldIndex: number, newIndex: number) => void;
    draggable?: boolean;
};

export const ShortListWinnerProjectsEdit: FC<ShortListProjectsEditProps> = ({
    competitionId,
    projects,
    onSetProjects,
    onRebuildProjects,
    onSetPosition,
    onSort,
    draggable = false
}) => {
    const { t, i18n } = useTranslation();
    const modal = useModal();
    const isMobile = useBreakpoint(LayoutConst.screen.s - 1);
 
    const [editedItems, setEditedItems] = useState<({ project?: Project, position?: number, isEmpty?: boolean, projectId?: string })[]>([]);

    useEffect(() => {

        if (projects.length) {
            ProjectAPI.GetList({
                    projectIds: projects.map(x => x.winnerId),
                    projectFilter: 1,
                    isLite: true,
                    isContextIgnored: true,
                    onlyBooks: ''
                })
                .then(v => v.json())
                .then((v) => API.toLang<PageModel<Project>>(v, i18n.language))
                .then((v) => {
                    if (v?.data?.length) {
                        const prjs = [...v.data];
                        prjs.sort((a: Project, b: Project): number => {
                            const index_a = projects.map(x => x.winnerId).indexOf(a.projectId);
                            const index_b = projects.map(x => x.winnerId).indexOf(b.projectId);

                            if (index_a < index_b) {
                              return -1;
                            }
                            if (index_a > index_b) {
                              return 1;
                            }
                            // a must be equal to b
                            return 0;
                        });

                        const prjItems = prjs.map(x => {
                            const winner = projects.find(f => f.winnerId === x.projectId);

                            return { project: x, position: winner?.position ?? 1 }
                        });

                        setEditedItems([...prjItems])
                    } 
                });
        }
    }, [projects, i18n]);

    const tabsComponent = useMemo(() => (<CompetitionModalTabs />), [])

    const onAddProject = useCallback((index: number, projectId: string) => {
        const temp = [...editedItems];
        temp[index] = {...temp[index], projectId: projectId }
        setEditedItems(temp);
    }, [editedItems])

    const onSelectClick = useCallback((index: number, position?: number) => {
        modal.show('select-short-list', {
            competitionId: competitionId,
            projectIds: projects.filter(x => x.winnerId !== '')?.map((i) => i?.winnerId),
            onSetProjects: onSetProjects,
            onAddProject: onAddProject,
            sortingMethods: [1,2,13],
            searchData: { id: competitionId },
            sendText: t('competitions_edit.btns.save'),
            modalType: MODAL_TYPE.short_list,
            position: position,
            index: index,
            tabs: tabsComponent,
        });
    }, [modal, tabsComponent, competitionId, projects, onSetProjects, onAddProject, t]);

    const onSortEnd = useCallback((oldIndex: number, newIndex: number) => {
        const arr = arrayMoveImmutable(editedItems, oldIndex, newIndex)
        setEditedItems(arr)
        onRebuildProjects(arr)
    }, [onSort, editedItems])

    const onSetLocalPosition = useCallback((index: number, position: number, isEmpty?: boolean) => {
        const temp = [...editedItems];
        temp[index].position = position;
        setEditedItems(temp);
        if (!isEmpty) onSetPosition(index, position)
    }, [onSetPosition, editedItems])

    const onDelete = useCallback((index: number, position?: number) => {
        const temp = [...editedItems];
        temp.splice(index, 1);
        onRebuildProjects(temp.map(x => ({projectId: x?.project?.projectId || "", position: x?.position, isEmpty: false})), true)
        setEditedItems(temp.map(x => ({projectId: x?.project?.projectId || "", position: x?.position, isEmpty: false})));
    }, [editedItems, onRebuildProjects])

    if (!editedItems?.length) {
        return (
            <DefaultButton isCompetitionEdit onClick={() => onSelectClick(0)} hollow>{t('competition_edit.choose_winner_new')}</DefaultButton>
        )
    }

    return (
        <FlexBox direction="column" directionMobile="column" gy={12} gyMobile={12}>
        <GlobalDragStyle/>
        <TableWrapper width={'100%'} >
          <thead>
            <tr>
              <th className=''>{isMobile ? 'Место' : ''}</th>
              <th className='width-place vertical-th jury-sum'>
                  {!isMobile ? 'Место' : 'Проект'}
              </th>
              <th className='width-name project-name'>
                  {isMobile ? 'Автор' : 'Проект'}
              </th>
              <th className='width-author author-name'>{isMobile ? 'Балл' : 'Автор'}</th>
              <th className='width-points vertical-th jury-sum'>{isMobile ? '': 'Балл'}</th>
              <th className=''></th>
            </tr>
          </thead>
                        {draggable
                            ? <SortableList as={'tbody'}  onSortEnd={onSortEnd} className="sortable-short-list" lockAxis="y" draggedItemClassName="sortable-short-list-item-draggable">
                                    {editedItems?.map((value, index) => {
                                        const projectTitle: any = !!value?.project?.title ? value.project.title : value.project?.additionalContent?.title?.text;
                                        if (value?.isEmpty !== undefined) return <SortableItem key={index + "sortable-empty"}>
                                            <tr className="sortable-short-list-item" style={{height: 42}}>
                                                <td className={''}></td>
                                                <TdPlace>
                                                    <WinnerInputWrapper 
                                                        className={'td-content'}
                                                        direction="column"
                                                        directionMobile="column" isTeamEdit
                                                        >
                                                        {value?.position || 1}
                                                    </WinnerInputWrapper>
                                                </TdPlace>
                                                <TdButton>
                                                    <AddWinnerbutton onClick={() => onSelectClick(index, value?.position)}>{t('competition_edit.choose_winner')}</AddWinnerbutton>
                                                </TdButton>
                                            </tr>
                                        </SortableItem>

                                        if (value?.project && value?.position !== undefined) return <SortableItem key={value.project.projectId + "sortable"}>
                                            <tr className="sortable-short-list-item" style={{height: 42 }}>
                                                <TdDrag width={24}>
                                                    <SortableKnob>
                                                        <DragIcon/>
                                                    </SortableKnob>
                                                </TdDrag>
                                                <TdPlace>
                                                    <WinnerInputWrapper 
                                                      className={'td-content td-dropdown'}
                                                      direction="column"
                                                      directionMobile="column" 
                                                      isTeamEdit
                                                      >
                                                        <Input.Text
                                                          value={value?.position}
                                                          onChange={(ev: any) => {
                                                            onSetLocalPosition(index, Number(ev.target.value))
                                                          }}
                                                        />
                                                    </WinnerInputWrapper>
                                                </TdPlace>
                                                <TdTitle>
                                                    <div className={'td-content td-title'}>
                                                        <Link to={CreateLinkTo.projectNew(value.project)}
                                                              target={"_blank"}>{projectTitle}</Link>&nbsp;&nbsp;
                                                    </div>
                                                </TdTitle>
                                                <TdAuthor>
                                                  <div className={'td-content td-author'}>
                                                    <Link to={CreateLinkTo.designerNew(value.project.author)}
                                                          target={"_blank"}>{value.project.author.name + ' ' + value.project.author.surName}</Link>&nbsp;&nbsp;
                                                          </div>
                                                </TdAuthor>
                                                <TdSum>
                                                    <div className={'td-content td-sum'}  style={{ justifyContent: 'center' }}>
                                                        {value.project.competitonsGPA?.find(x => x.competitionId === competitionId)?.competitionGPA ?? "0"}
                                                    </div>
                                                </TdSum>
                                                <TdDel>
                                                    <div className={'td-content td-delete'} style={{cursor: 'pointer'}} onClick={() => onDelete(index, value?.position)}>
                                                      <DeleteIcon/>
                                                    </div>
                                                </TdDel>
                                            </tr>
                                        </SortableItem>
                                    })}
                                </SortableList>
                            : <tbody className="short-list">
                                    {editedItems?.map((value, index) => {
                                        const projectTitle: any = !!value?.project?.title ? value.project.title : value.project?.additionalContent?.title?.text;
                                        if (value?.isEmpty !== undefined) return <tr className="sortable-short-list-item" style={{height: 42}}>
                                                <TdPlace>
                                                    <WinnerInputWrapper 
                                                      className={'td-content'} 
                                                      direction="column"
                                                      directionMobile="column" 
                                                      isTeamEdit
                                                    >
                                                        <Input.Dropdown
                                                            value={{
                                                                label: value?.position || 1,
                                                                value: value?.position || 1
                                                            }}
                                                            onChange={(ev: any) => onSetLocalPosition(index, Number(ev.value), true)}
                                                            options={[{label: 1, value: 1}, {label: 2, value: 2}, {label: 3, value: 3}, {label: 4, value: 4}, {
                                                                label: 5,
                                                                value: 5
                                                            }]
                                                          }
                                                        />
                                                    </WinnerInputWrapper>
                                                </TdPlace>
                                                <TdButton>
                                                    <AddWinnerbutton onClick={() => onSelectClick(index, value?.position)}>{t('competition_edit.choose_winner')}</AddWinnerbutton>
                                                </TdButton>
                                            </tr>

                                        if (value?.project && value?.position !== undefined) return <tr className="sortable-short-list-item" style={{height: 42}}>
                                                <TdPlace>
                                                    <WinnerInputWrapper 
                                                      className={'td-content'} 
                                                      direction="column"
                                                      directionMobile="column" 
                                                      isTeamEdit
                                                    >
                                                        
                                                        {!isMobile ? (
                                                          <Input.Dropdown
                                                            value={{
                                                                label: value?.position || 1,
                                                                value: value?.position || 1
                                                            }}
                                                            onChange={(ev: any) => onSetPosition(index, Number(ev.value))}
                                                            options={
                                                              [{label: 1, value: 1}, {label: 2, value: 2}, {label: 3, value: 3}, {label: 4, value: 4}, {
                                                                label: 5,
                                                                value: 5
                                                            }]
                                                          }
                                                          />
                                                        ) : (
                                                          <span>{index + 1}</span>
                                                        )}
                                                       
                                                    </WinnerInputWrapper>
                                                </TdPlace>
                                                <TdTitle width={'100% !important'}>
                                                    <div className={'td-content'} style={{ width: '100%' }}>
                                                        <Link to={CreateLinkTo.projectNew(value.project)}
                                                              target={"_blank"}>{projectTitle}</Link>&nbsp;&nbsp;
                                                    </div>
                                                </TdTitle>
                                                <TdAuthor>
                                                    <Link className={'td-content'} style={{ height: '100%'}} to={CreateLinkTo.designerNew(value.project.author)}
                                                          target={"_blank"}>{value.project.author.name + ' ' + value.project.author.surName}</Link>&nbsp;&nbsp;
                                                </TdAuthor>
                                                <TdSum style={{ width: '65px !important'}}>
                                                    <div className={'td-content'} style={{ placeItems: 'center' }}>
                                                        {value.project.competitonsGPA?.find(x => x.competitionId === competitionId)?.competitionGPA ?? "Нет оценок"}
                                                    </div>
                                                </TdSum>
                                                {!isMobile && (
                                                  <TdDel style={{ width: '24px !important' }}>
                                                    <div className={'td-content td-delete'} style={{cursor: 'pointer'}} onClick={() => onDelete(index, value?.position)}>
                                                        <DeleteIcon/>
                                                    </div>
                                                  </TdDel>
                                                )}
                                            </tr>
                                    })}
                                </tbody>
                        }
        </TableWrapper>
            {editedItems?.some((i: any) => !i?.isEmpty) && <div>
                <DefaultButton isCompetitionEdit hollow onClick={() => onSelectClick(projects?.length, projects?.length + 1)}><PlusSvg />{t('competition_edit.add_win_place')}</DefaultButton>
            </div>}
        </FlexBox>
    );
};